import { default as OwnerPersonalPage } from './OwnerPersonalPage'
export { default as OwnerPersonalPageReducer } from './model/slice'
export default OwnerPersonalPage
